import * as types from './types';

export const codeSetupBox = ({ commit }, box) => {
  commit(types.CODE_SET_BOX, box);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/code/actions.js
 **/